export enum BroadcastStatus {
    NONE = 'NONE',
    STREAMING_REQUESTED = 'STREAMING_REQUESTED',            // PT
    CONTAINER_SELECTION = 'CONTAINER_SELECTION',            // SS
    CONTAINER_MEETING_SYNC = 'CONTAINER_MEETING_SYNC',      // SS
    CONTAINER_CASPARCG_SYNC = 'CONTAINER_CASPARCG_SYNC',    // SS
    CONTAINER_UDP_SYNC = 'CONTAINER_UDP_SYNC',              // SS
    LIVE = 'LIVE',                                          // SS
    IN_EVENT = 'IN_EVENT',                                  // PT
    PAUSE_REQUESTED = 'PAUSE_REQUESTED',                    // PT
    CONTAINER_LIVE_ENDING = 'CONTAINER_LIVE_ENDING',        // SS
    TERMINATED = 'TERMINATED',                              // SS
    PAUSE_EVENT = 'PAUSE_EVENT'                             // PT
}

export interface BroadcastEvent {
    status: BroadcastStatus;
    from: 'primetime' | 'studio_server' | null;
    date: number;
}